<template>
    <div>
        <card-header title="Search Leads" icon="fa-address-card"/>

        <card-body>
            <card-list>
                <subheader-list-item :title="props.query" icon="fa-align-left" :badge="results.count + ' Results'"/>

                <lead-list-item
                    :card="card"
                    :lead="l"
                    v-for="l in results.leads"
                    :key="l.id"
                    :active="child && child.definition.component === 'lead' && child.props.leadId === l.id.toString()"
                    @click="$openCard('lead', {leadId: l.id}, card);"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardList from "../../TIER/components/CardList";
    import CardBody from "@/TIER/components/CardBody";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import LeadListItem from "@/components/LeadListItem";
    import {client as http} from "@/http_client";

    export default {
        name: "SearchLeads",
        props: ['card', 'child', 'props'],
        components: {LeadListItem, SubheaderListItem, CardBody, CardList, CardHeader},
        data: function() {
            return {
                results: {
                    count: 0,
                    leads: []
                }
            };
        },
        methods: {
            loadLeads(force) {
                this.$emit('loading', true);
                http.get('/api/leads/search/' + this.props.query + '/0/50', {force}).then(response => {
                    this.results = response.data;
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.loadLeads(true);
            }
        },
        watch: {
            'props.query': function() {
                this.loadLeads(true);
            }
        },
        mounted() {
            this.loadLeads();
        }
    };
</script>

<style lang="scss" scoped>

</style>
